import { isArray, isEmpty, isObject } from "lodash-es";
//#region src/index.tsx
function isValidContentArray(object) {
	if (!isArray(object)) return false;
	for (const o of object) if (!isValidContent(o)) return false;
	return true;
}
function isValidContent(object) {
	return isObject(object) && !isEmpty(object.name) && (!isEmpty(object.uuid) || object.uuid === 0);
}
//#endregion
export { isValidContent, isValidContentArray };
